import {
  initialState,
  Actions,
  State,
  EDIT_WELCOME_CONTENT_SECTION,
  EDIT_WELCOME_CONTENT_SECTION_SUCCESS,
  EDIT_WELCOME_CONTENT_SECTION_ERROR,
  RESET_EDIT_WELCOME_CONTENT_SECTION,
} from "../../types/welcome-content/edit-welcome-content-section";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_WELCOME_CONTENT_SECTION:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_WELCOME_CONTENT_SECTION_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_WELCOME_CONTENT_SECTION_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_WELCOME_CONTENT_SECTION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
